module.exports = __webpack_public_path__ + "media/images/lb/441-a8bd7b64bbacf3f76ca3c22b5d1e1489.svg";